export class AddEditUserPageController {
    /*@ngInject*/
    constructor($scope, $rootScope, $state, $timeout, $filter, $uibModal, $transitions, StorageService, utilityService, userRoleService, employeeService, userService, companyService, USERMANAGEMENTCONSTANTS, MESSAGECONSTANTS, alertsAndNotificationsService, uibModalService) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.$uibModal = $uibModal;
        this.$transitions = $transitions;
        this.StorageService = StorageService;
        this.utilityService = utilityService;
        this.userRoleService = userRoleService;
        this.employeeService = employeeService;
        this.userService = userService;
        this.companyService = companyService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.USERMANAGEMENTCONSTANTS = USERMANAGEMENTCONSTANTS;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.uibModalService = uibModalService;
    }
    $onInit() {
        this.$stateParams = this.$transition$.params();
        this.form = {};
        this.userProfile = {};
        this.userProfileReset = {};
        this.userProfile.userDetails = {};
        this.userProfile.userScopeDetails = {};
        this.userProfile.userForwardRecipientDetails = {};
        this.companyType = this.$rootScope.userDetails.company.companyType;
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.isCorporateFlag = (this.$rootScope.userDetails.company.companyType == 'Corporation');
        this.forwardRecipients = [];
        this.geoLocations = [];
        this.geoLocationsCopy = [];
        this.lastStep = false;
        this.profilePic = '';
        this.roleChanged = false;
        this.oldRole = null;
        this.managerChanged = false;
        this.oldManager = null;
        this.userCreated = false;
        this.roles = [];
        this.buList = [];
        this.clientsOrBUList = [];
        this.selectedDepartmentObjectsArray = [];
        this.switchClicked = false;
        this.showConfirmationPopup = false;
        this.copyCompanyAddress = false;
        this.zipCodeCalling = false;
        this.zipCodeCallCompleted = false;
        this.isLocationChange = false;
        this.isLocationChangeInitial = false;
        this.isUserBelongsToBUChanged = false;
        this.editProfileEnabled = false;
        this.isLoading = true;
        this.formSubmitted = false;
        this.valid = false;
        this.triggerCount = 0;
        this.updatedManager = null;
        this.telephoneNumberFormat = '+1 201-555-0123';
        this.mobileNumberFormat = '+1 201-555-0123';
        this.countryCodeForTelephone = 'us';
        this.countryCodeForTelephone = 'us';
        this.fromUserProfile = angular.copy(this.$stateParams.purpose);
        this.isValidWorkTelephoneEntered = false;
        this.isValidMobileNumberEntered = false;
        this.mobileNumberDirty = false;
        this.workTelephoneDirty = false;
        this.canAddUserAtCompanyLevel = false;
        this.canAddUserAtDepartmentOrBULevel = false;
        this.nextButtonFlag = 0;
        this.saveButtonFlag = 0;
        this.recentButtonClick = 'nextButton';
        this.dateTimeCount = 0;
        this.saveButtonClicked = false;
        this.nextButtonClicked = false;
        this.cancelClicked = false;
        this.isCountyExists = false;
        this.isInHost = this.utilityService.isInHost();
        this.isStaffingCompany = this.companyService.isStaffingCompany();
        this.isCorporateCompany = this.companyService.isCorporateCompany();
        this.accessMode = angular.copy(this.$stateParams.accessMode);
        this.managerDetails = angular.copy(this.$stateParams.manager);
        this._handleBrowserEvents();
        if (this._isCreateUserUnderManager()) {
            this.isLoading = false;
            if (!angular.equals(this.managerDetails, null) && !angular.equals(this.managerDetails.lastName, null)) {
                this.managerDetails.firstName = this.managerDetails.firstName + ' ' + this.managerDetails.lastName;
            }
            this.StorageService.set('useraccessmode', this.accessMode);
            this.StorageService.remove('userProfile');
            this.StorageService.set('manager', this.managerDetails);
            this.userProfile.departmentId = null;
            this.userProfile.deparmentName = null;
            this.userProfile.buId = null;
            this.userProfile.buName = null;
            this.userProfile.isPointOfContact = false;
            this.userProfileReset = angular.copy(this.userProfile);
            this.userService.getUserRoleEntityScopeById(this.managerDetails.userId, this.companyId, this.managerDetails.roleId, (data) => {
                this.clientOrBUList = data.clientOrBUList;
            }, (error) => {
                if (this.$rootScope.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
                console.log('error');
            });
            this._getUserBelongsTo();
            this._getRolesInTheCompany();
            this._setDepartment();
            this._createWizard();
            this._setPhoneNumberFields();
        }
        else if (this._isEditOrViewUser()) {
            this._getUserProfileInfo(() => {
                this.isLoading = false;
                //view or update user access
                //Setting the Phone number values to be true
                this.isValidMobileNumberEntered = true;
                this.isValidWorkTelephoneEntered = true;
                this.$timeout(() => {
                    this._getAddressDetails(angular.copy(this.userObject.userDetails.zipcode), 'start', (response) => {
                        this.geoLocationsCopy = angular.copy(this.geoLocations);
                    });
                }, 500);
                this.StorageService.set('useraccessmode', this.accessMode);
                this.StorageService.remove('manager');
                this.StorageService.set('userProfile', angular.copy(this.userObject));
                this.userProfile = angular.copy(this.userObject);
                if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.VIEW) {
                    // this.isLoading = false;
                    //access mode view
                    this.$timeout(() => {
                        angular.element('.access').attr({ 'readonly': true, 'disabled': true });
                    }, 200);
                    if (!angular.equals(this.userProfile.userForwardRecipientDetails, null)) {
                        if (!angular.equals(this.userProfile.userForwardRecipientDetails.forwardRecipient, null)) {
                            if (angular.isDefined(this.userProfile.userForwardRecipientDetails.forwardRecipient.userId)) {
                                this.userProfile.userForwardRecipientDetails.forwardRecipient.ticked = true;
                                if (this.userProfile.userForwardRecipientDetails.forwardRecipient.lastName != null) {
                                    var output = this.userProfile.userForwardRecipientDetails.forwardRecipient.firstName + " " + this.userProfile.userForwardRecipientDetails.forwardRecipient.lastName;
                                }
                                else {
                                    var output = this.userProfile.userForwardRecipientDetails.forwardRecipient.firstName;
                                }
                                if (output.length > 57) {
                                    this.userProfile.userForwardRecipientDetails.forwardRecipient["fullName"] = output.substring(0, 57) + "...";
                                }
                                else {
                                    this.userProfile.userForwardRecipientDetails.forwardRecipient["fullName"] = output;
                                }
                                this.forwardRecipients.push(this.userProfile.userForwardRecipientDetails.forwardRecipient);
                            }
                        }
                    }
                    this.originalManagerObj = angular.copy(this.userProfile.userDetails.manager);
                    if (!angular.equals(this.originalManagerObj, null) && !angular.equals(this.originalManagerObj.lastName, null)) {
                        this.originalManagerObj.firstName = this.originalManagerObj.firstName.split(" ")[0];
                    }
                }
                else if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
                    //access mode edit
                    angular.element('#email').attr({ 'readonly': true, 'disabled': true });
                    if ((this.userProfile.userDetails.userId === this.$rootScope.userDetails.id)) {
                        angular.element('#role').attr({ 'readonly': true, 'disabled': true });
                        this.editProfileEnabled = true;
                    }
                    if (this.isCompanyAdmin(this.userProfile.userDetails.role)) {
                        angular.element('#manager').attr({ 'readonly': true, 'disabled': true });
                    }
                    this.originalManagerObj = angular.copy(this.userProfile.userDetails.manager);
                    if (!angular.equals(this.originalManagerObj, null) && !angular.equals(this.originalManagerObj.lastName, null)) {
                        this.originalManagerObj.firstName = this.originalManagerObj.firstName.split(" ")[0];
                    }
                    this._populateForwardRecipient();
                }
                this.userProfileReset = angular.copy(this.userProfile);
                this.userService.getUserRoleEntityScopeById(this.userProfile.userDetails.userId, this.companyId, this.userProfile.userDetails.role.id, (data) => {
                    this.clientOrBUList = data.clientOrBUList;
                }, (error) => {
                    if (this.$rootScope.isOnline) {
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                    console.log('error');
                });
                this._getUserBelongsTo();
                this._getRolesInTheCompany();
                this._setDepartment();
                this._createWizard();
                this._setPhoneNumberFields();
            });
        }
        else {
            // when refresh
            var useraccessmode = this.StorageService.get('useraccessmode');
            var userProfile = this.StorageService.get('userProfile');
            var manager = this.StorageService.get('manager');
            if ((manager !== null) && (useraccessmode !== null) && (userProfile === null)) {
                // create mode
                this.managerDetails = manager;
                this.accessMode = useraccessmode;
                this.userProfileReset = angular.copy(this.userProfile);
            }
            else if ((userProfile !== null) && (useraccessmode !== null) && (manager === null)) {
                //update or view mode
                this.userProfile = userProfile;
                this.accessMode = useraccessmode;
                this.StorageService.remove('manager');
                if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.VIEW) {
                    angular.element('.access').attr({ 'readonly': true, 'disabled': true });
                }
                else if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
                    //access mode edit
                }
                this.userProfileReset = angular.copy(this.userProfile);
            }
            else {
                // if objects are not there both in storage and stateparams
                console.log('objects are not there both in storage and stateparams');
            }
            this._getRolesInTheCompany();
            this._setDepartment();
            this._createWizard();
            this._setPhoneNumberFields();
        }
        this.$timeout(() => {
            // this.form.userDetailsForm.$setPristine();
            if (document.getElementById('workTelephone') && document.getElementById('workTelephone').value.length > 0) {
                this.workTelephoneDirty = true;
            }
            if (document.getElementById('mobileNumber') && document.getElementById('mobileNumber').value.length > 0) {
                this.mobileNumberDirty = true;
            }
        }, 1500);
        // determine if add user option is allowed for this user
        if (this.userRoleService.isLoggedInUserAnAdmin()) {
            // admin user, add user is allowed in all cases
            this.canAddUserAtCompanyLevel = true;
            this.canAddUserAtDepartmentOrBULevel = true;
        }
        else {
            // if it is corporation, check bu permissibility
            if (this.isCorporateFlag) {
                // for non admin user
            }
            else {
                // for staffing, as of now employees can be added at all levels by all users
                this.canAddUserAtCompanyLevel = true;
                this.canAddUserAtDepartmentOrBULevel = true;
            }
        }
    }
    _setPhoneNumberFields() {
        $(document).ready(() => {
            this.$timeout(() => {
                $("#workTelephone").on("countrychange", (e, countryData) => {
                    this.countryCodeForTelephone = countryData.iso2;
                    this.form.userDetailsForm.workTelephone.$setDirty();
                    if (this.countryCodeForTelephone !== undefined) {
                        this._setWorkTelephoneCountryCode();
                    }
                });
                $("#mobileNumber").on("countrychange", (e, countryData) => {
                    this.countryCodeForTelephone = countryData.iso2;
                    this.form.userDetailsForm.mobileNumber.$setDirty();
                    if (this.countryCodeForTelephone !== undefined) {
                        this._setMobileNumberCountryCode();
                    }
                });
                $("#workTelephone").keyup(() => {
                    if (document.getElementById('workTelephone').value.length > 0) {
                        this.workTelephoneDirty = true;
                    }
                    else {
                        this.workTelephoneDirty = false;
                    }
                });
                $("#mobileNumber").keyup(() => {
                    if (document.getElementById('mobileNumber').value.length > 0) {
                        this.mobileNumberDirty = true;
                    }
                    else {
                        this.mobileNumberDirty = false;
                    }
                });
            }, 2000);
        });
    }
    _isCreateUserUnderManager() {
        return this.$stateParams.manager !== null && this.$stateParams.accessMode === 'create';
    }
    _isEditOrViewUser() {
        return this.$stateParams.accessMode !== 'create' && this.$stateParams.manager === null;
    }
    _getUserBelongsTo() {
        let managerUserId = '';
        let userId = '';
        let isManager = true;
        if (this._isCreateUserUnderManager()) {
            managerUserId = this.managerDetails.userId;
        }
        else if (this.originalManagerObj) {
            managerUserId = this.originalManagerObj.userId;
            userId = this.userProfile.userDetails.userId;
        }
        else {
            userId = this.userProfile.userDetails.userId;
        }
        if (managerUserId === this.$rootScope.userDetails.id) {
            managerUserId = '';
        }
        this.userService.getUserBelongsTo(this.companyId, managerUserId, userId, (data) => {
            this.buList = data.buInfos;
            if (data.belongsToCorp) {
                this.canAddUserAtCompanyLevel = true;
                this.canAddUserAtDepartmentOrBULevel = true;
            }
            else {
                this.canAddUserAtCompanyLevel = false;
                this.canAddUserAtDepartmentOrBULevel = true;
            }
            this._setBuName();
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            console.log('error');
        });
    }
    _setBuName() {
        var bu = _.filter(this.buList, (bu) => {
            return this.userProfile.buId === bu.id;
        });
        //if the exising bu is not present in the bulist got for logged in user
        if (this.userProfile.buId !== null && this.userProfile.buId !== "" && bu.length == 0) {
            var buObject = { id: this.userProfile.buId, name: this.userProfile.buName };
            this.buList.push(buObject);
            bu.push(buObject);
        }
        if (bu.length > 0) {
            this.selectedBuName = bu[0].name;
        }
        else {
            this.selectedBuName = 'Corporate';
        }
    }
    _getRolesInTheCompany() {
        if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
            var managerId = this.managerDetails.roleId;
        }
        if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
            this.userService.getUserCreateRoles(managerId, this.$rootScope.userDetails.company.companyType, (data) => {
                this.roles = data;
                if (this.isInHost) {
                    for (var i = 0; i < this.roles.length; i++) {
                        if (this.roles[i].name === this.MESSAGECONSTANTS.ROLES.FOURDOTFIVEADMIN) {
                            this.userProfile.userDetails.role = this.roles[i];
                            this.userProfileReset.userDetails.role = this.roles[i];
                        }
                    }
                }
                else if (this.isStaffingCompany || this.isCorporateCompany) {
                    if (this.roles.length === 1) {
                        this.userProfile.userDetails.role = this.roles[0];
                        this.userProfileReset.userDetails.role = this.roles[0];
                    }
                    else if (this.roles.length > 1) {
                        for (var i = 0; i < this.roles.length; i++) {
                            if (this.roles[i].name === this.MESSAGECONSTANTS.ROLES.RECRUITER) {
                                this.userProfile.userDetails.role = angular.copy(this.roles[i]);
                                this.userProfileReset.userDetails.role = angular.copy(this.roles[i]);
                            }
                        }
                    }
                }
                if (!((this.roles.length === 1) && this.isCompanyAdmin(this.roles[0]))) {
                    this.userProfile.userDetails.manager = this.managerDetails;
                    this.userProfileReset.userDetails.manager = this.managerDetails;
                }
            }, (error) => {
                if (this.$rootScope.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
        }
        else if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
            //Setting the Phone number values to be true
            this.isValidMobileNumberEntered = true;
            this.isValidWorkTelephoneEntered = true;
            //Setting manager role id
            let managerToGetRoles = this.StorageService.get('managers');
            if (angular.isDefined(managerToGetRoles) && (managerToGetRoles !== null) && (managerToGetRoles.length > 0)) {
                managerId = managerToGetRoles[0].roleId;
            }
            if (this.isFourDotFiveAdmin(this.$rootScope.userDetails.roleScreenRef.role) || this.isSuperUser(this.$rootScope.userDetails.roleScreenRef.role)) {
                if (this.isFourDotFiveAdmin(this.$rootScope.userDetails.roleScreenRef.role) && this.isFourDotFiveAdmin(this.userProfileReset.userDetails.role)) {
                    this.roles = [];
                    this.roles.push(this.userProfileReset.userDetails.role);
                }
                else {
                    this.userService.getUserUpdateRoles(managerId, this.$rootScope.userDetails.company.companyType, (data) => {
                        this.roles = data;
                        this.form.userDetailsForm.$setPristine();
                    }, (error) => {
                        if (this.$rootScope.isOnline) {
                            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        }
                    });
                }
            }
            else {
                if (this.userProfile.userDetails.manager !== null) {
                    this.userService.getUserUpdateRoles(this.userProfileReset.userDetails.manager.roleId, this.$rootScope.userDetails.company.companyType, (data) => {
                        this.roles = data;
                        this.form.userDetailsForm.$setPristine();
                    }, (error) => {
                        if (this.$rootScope.isOnline) {
                            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        }
                    });
                }
                else {
                    this.roles.push(this.userProfile.userDetails.role);
                }
            }
            //get managers list
            if (!this.isCompanyAdmin(this.userProfileReset.userDetails.role)) {
                this._getManagersList(angular.copy(this.userObject.userDetails.userId), angular.copy(this.userObject.userDetails.role.id), this.userObject.buId);
            }
            else {
                this.isLoading = false;
            }
        }
        else if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.VIEW) {
            this.roles.push(this.userProfile.userDetails.role);
        }
    }
    _getManagersList(userId, roleId, buId) {
        if (!(this.isCorporateFlag && !_.isNull(buId) && buId !== "" && buId !== undefined)) {
            buId = null;
        }
        this.userService.getManagers(userId, roleId, buId, (data) => {
            this.managerList = data;
            if ((this.userProfile.userDetails.role.name === this.MESSAGECONSTANTS.ROLESNAMES.FOURDOTFIVEADMIN_NAME)) {
                this.managerList.push(this.userProfile.userDetails.manager);
            }
            this.isLoading = false;
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            console.log('error : ' + angular.toJson(error));
        });
    }
    _setDepartment() {
        if (!_.isNull(this.userProfile.departmentId)) {
            var department = {};
            department.id = this.userProfile.departmentId;
            department.name = this.userProfile.departmentName;
            this.selectedDepartmentObjectsArray.push(department);
        }
    }
    isWorkTelephoneValid(workTelephoneValue) {
        if (workTelephoneValue !== "") {
            if ($("#workTelephone").intlTelInput("isValidNumber")) {
                this.isValidWorkTelephoneEntered = true;
                this.userProfile.userDetails.workTelephone = this.$filter('phonenumber')(workTelephoneValue, this.telephoneNumberFormat);
                this.form.userDetailsForm.workTelephone.$setValidity('ng-intl-tel-input', true);
            }
            else {
                this.emptyUserworkTelephone = false;
                this.invalidUserworkTelephone = true;
                this.isValidWorkTelephoneEntered = false;
                this.workTelephoneValueTrim = document.getElementById('workTelephone').value;
                this.userProfile.userDetails.workTelephone = this.workTelephoneValueTrim.replace(/ |-/gm, '');
                this.form.userDetailsForm.workTelephone.$setValidity('ng-intl-tel-input', false);
            }
        }
        else {
            this.emptyUserworkTelephone = true;
            this.invalidUserworkTelephone = false;
            this.isValidWorkTelephoneEntered = false;
        }
    }
    isMobileNumberValid(mobileNumberValue) {
        if (mobileNumberValue !== "") {
            if ($("#mobileNumber").intlTelInput("isValidNumber")) {
                this.isValidMobileNumberEntered = true;
                this.userProfile.userDetails.mobileNumber = this.$filter('phonenumber')(mobileNumberValue, this.mobileNumberFormat);
                this.form.userDetailsForm.mobileNumber.$setValidity('ng-intl-tel-input', true);
            }
            else {
                this.emptyUsermobileNumber = false;
                this.invalidUsermobileNumber = true;
                this.isValidMobileNumberEntered = false;
                this.mobileNumberValueTrim = document.getElementById('mobileNumber').value;
                this.userProfile.userDetails.mobileNumber = this.mobileNumberValueTrim.replace(/ |-/gm, '');
                this.form.userDetailsForm.mobileNumber.$setValidity('ng-intl-tel-input', false);
            }
        }
        else {
            this.emptyUsermobileNumber = true;
            this.invalidUsermobileNumber = false;
            this.isValidMobileNumberEntered = false;
        }
    }
    //mobile number methods end
    getZipCodeDetails(zipcode, type) {
        this.nextButtonClicked = false;
        this.saveButtonClicked = false;
        if (this.form.userDetailsForm.zipcode.$valid) {
            this.zipCodeCalling = true;
            this.zipCodeCallCompleted = false;
            if (angular.isDefined(zipcode)) {
                this.cancelClicked = false;
            }
            this._getAddressDetails(zipcode, type, (response) => {
                if (angular.isDefined(this.userProfileReset.userDetails.county) && (this.userProfileReset.userDetails.county !== null)
                    && (this.userProfile.userDetails.zipcode === this.userProfileReset.userDetails.zipcode)) {
                    this.userProfile.userDetails.county = this.userProfileReset.userDetails.county;
                    // this.$scope.safeApply();
                }
                if (this.saveButtonClicked) {
                    this._saveButtonTrigger();
                }
                else if (this.nextButtonClicked) {
                    this._nextButtonTrigger();
                }
            });
        }
        else {
            this.geoLocations = [];
            this.saveButtonClicked = false;
            this.nextButtonClicked = false;
            this.userProfile.userDetails.city = '';
            this.userProfile.userDetails.state = '';
            this.userProfile.userDetails.county = '';
            this.isCountyExists = false;
            this.userProfile.userDetails.country = '';
        }
    }
    /**
    * This method works for triggerng button clicks on save button
    *  only for on blur validations
    */
    _saveButtonTrigger() {
        var savebtnclick = this.$timeout(() => {
            angular.element('.btn-save').triggerHandler('click');
        }, 0).then(() => {
            this.saveButtonClicked = false;
            this.nextButtonClicked = false;
            this.$timeout.cancel(savebtnclick);
        });
    }
    /**
     * This method works for triggerng button clicks on save button
     *  only for on blur validations
     */
    _nextButtonTrigger() {
        var nextbtnclick = this.$timeout(() => {
            angular.element('.create-next').triggerHandler('click');
        }, 0).then(() => {
            this.zipCodeCalling = false;
            this.zipCodeCallCompleted = false;
            this.nextButtonClicked = false;
            this.saveButtonClicked = false;
            this.$timeout.cancel(nextbtnclick);
        });
    }
    _populateForwardRecipient() {
        if (!angular.equals(this.userProfile.userForwardRecipientDetails, null)) {
            if (!angular.equals(this.userProfile.userForwardRecipientDetails.forwardRecipient, null)) {
                if (angular.isDefined(this.userProfile.userForwardRecipientDetails.forwardRecipient.userId)) {
                    if (this.userProfile.userForwardRecipientDetails.forwardRecipient.lastName != null) {
                        var output = this.userProfile.userForwardRecipientDetails.forwardRecipient.firstName + ' ' + this.userProfile.userForwardRecipientDetails.forwardRecipient.lastName;
                    }
                    else {
                        var output = this.userProfile.userForwardRecipientDetails.forwardRecipient.firstName;
                    }
                    if (output.length > 57) {
                        this.userProfile.userForwardRecipientDetails.forwardRecipient["fullName"] = output.substring(0, 57) + "...";
                    }
                    else {
                        this.userProfile.userForwardRecipientDetails.forwardRecipient["fullName"] = output;
                    }
                    this.forwardRecipients.push(angular.copy(this.userProfile.userForwardRecipientDetails.forwardRecipient));
                }
            }
        }
    }
    // Address methods end
    _createWizard() {
        $(document).ready(() => {
            // var companyType = $('#hiddencompanyType').val();
            var companyType = this.companyType;
            $('#hiddencompanyType').hide();
            var is4dot5Admin = localStorage.getItem('myStorage-4dot5Admin');
            console.log('is4dot5Admin : ' + is4dot5Admin);
            //var userDetails = getCookie('myStorage-userDetails');
            if ((companyType === 'Host') || is4dot5Admin) {
                console.log('removing 3rd step');
                $('#myWizard').wizard('removeSteps', 3, 1).on('actionclicked.fu.wizard', (event, data) => {
                    var wizardoperations = localStorage.getItem('myStorage-wizardoperations');
                    if ((wizardoperations === null) || (wizardoperations !== 'true')) {
                        //console.log('preventing');
                        event.preventDefault();
                    }
                }).on('finished.fu.wizard', (event, data) => {
                    console.log('finished.fu.wizard : ');
                    // if ((wizardoperations === null) || (wizardoperations !== 'true')) {
                    //     console.log('preventing');
                    //     event.preventDefault();
                    // }
                }).on('stepclicked.fu.wizard', (event, data) => {
                    console.log('stepclicked.fu.wizard : ');
                    // if ((wizardoperations === null) || (wizardoperations !== 'true')) {
                    //     console.log('preventing');
                    //     event.preventDefault();
                    // }
                });
            }
            else {
                $('#myWizard').wizard()
                    .on('actionclicked.fu.wizard', (event, data) => {
                    var wizardoperations = localStorage.getItem('myStorage-wizardoperations');
                    //console.log('wizardoperations : '+wizardoperations);
                    if ((wizardoperations === null) || (wizardoperations !== 'true')) {
                        //console.log('preventing');
                        event.preventDefault();
                    }
                }).on('changed.fu.wizard', (event, data) => {
                    console.log('changed.fu.wizard : ');
                    localStorage.removeItem('myStorage-wizardoperations');
                }).on('stepclicked.fu.wizard', (event, data) => {
                    console.log('stepclicked.fu.wizard : ');
                    // if ((wizardoperations === null) || (wizardoperations !== 'true')) {
                    //     console.log('preventing');
                    //     event.preventDefault();
                    // }
                });
            }
            var currentDate = new Date();
            $('#fromDate').datepicker({
                format: 'M d, yyyy',
                startDate: currentDate,
                autoclose: true,
            });
            $('#toDate').datepicker({
                format: 'M d, yyyy',
                startDate: currentDate,
                autoclose: true
            });
            $('#fromTime').timepicker({
                minuteStep: 1,
                showSeconds: true,
                showMeridian: false,
                disableFocus: true,
                showWidget: true,
            }).focus(() => {
                $(this).next().trigger('click');
            });
            // angular.element('#fromTime').trigger('click');
            $('#toTime').timepicker({
                minuteStep: 1,
                showSeconds: true,
                showMeridian: false,
                disableFocus: true,
                showWidget: true
                // defaultTime : true
            }).focus(() => {
                $(this).next().trigger('click');
            });
            // angular.element('#fromTime').trigger('click');
            //masked inputs
            // $("#workTelephone").mask("9?99.999.999999999",{placeholder:" ",autoclear: false});
            /* $("#mobileNumber").mask("9?99.999.999999999",{placeholder:" ",autoclear: false}); */
            // $('#myWizard').bind("cut copy paste",function(e) {
            // 		e.preventDefault();
            // 	});
            $('.custom-file-upload').bind("click", () => {
                $('#inputImage').trigger('click');
            });
            $('#inputImage').change(() => {
                var filepath = $('#inputImage').val();
                var filename = filepath.split('\\').pop().split('/').pop(); //str.split('\\').pop().split('/').pop();
                $('#profilepicname').html(filename);
            });
        });
    }
    _setWorkTelephoneCountryCode() {
        $("#workTelephone").intlTelInput("setCountry", this.countryCodeForTelephone);
        this.telephoneNumberFormat = document.getElementById("workTelephone").placeholder;
        // this.$scope.safeApply();
        this.isWorkTelephoneValid(document.getElementById("workTelephone").value);
    }
    _setMobileNumberCountryCode() {
        $("#mobileNumber").intlTelInput("setCountry", this.countryCodeForTelephone);
        this.mobileNumberFormat = document.getElementById("mobileNumber").placeholder;
        // this.$scope.safeApply();
        this.isMobileNumberValid(document.getElementById("mobileNumber").value);
    }
    _getESfor4dot5Admin(callback) {
        this.utilityService.getCompaniesforUser(angular.copy(this.userProfile.userDetails.role), angular.copy(this.userProfile.userDetails.userId)).then((data) => {
            this.userProfile.userScopeDetails = data;
            this.userProfileReset.userScopeDetails = angular.copy(this.userProfile.userScopeDetails);
            this.StorageService.set('wizardoperations', true);
            this.stepTrigger('nextbtnclick');
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    /**
    * This method works for triggerng
    * button clicks and resetting timeout
    * and remaining variables to normal
    * @access for create, view and update
    */
    stepTrigger(target) {
        if (target === 'nextbtnclick') {
            var nextbtnclick = this.$timeout(() => {
                if (this.accessMode !== this.MESSAGECONSTANTS.ACCESS_MODES.VIEW) {
                    angular.element('.create-next').triggerHandler('click');
                }
                else {
                    angular.element('.view-next').triggerHandler('click');
                }
            }, 0).then(() => {
                this.triggerCount = 0;
                this.formSubmitted = false;
                this.StorageService.remove('wizardoperations');
                if ((this.userProfile.userDetails.role.name !== this.MESSAGECONSTANTS.ROLES.FOURDOTFIVEADMIN) && this.lastStep) {
                    this.form.userForwardRecipientsform.$setPristine();
                }
                this.$timeout.cancel(nextbtnclick);
            });
        }
        else if (target === 'cancelflow') {
            var steponeclick = this.$timeout(() => {
                angular.element('#1').trigger('click');
            }, 500).then(() => {
                this.triggerCount = 0;
                this.formSubmitted = false;
                this.StorageService.remove('wizardoperations');
                this.$timeout.cancel(steponeclick);
            });
        }
        else if (target === 'viewnext') {
            var viewnextbtnclick = this.$timeout(() => {
                angular.element('.view-next').triggerHandler('click');
            }, 0).then(() => {
                this.StorageService.remove('wizardoperations');
                this.triggerCount = 0;
                this.$timeout.cancel(viewnextbtnclick);
            });
        }
    }
    _createEntityScopeForAdmin() {
        let entityObj = {};
        entityObj.allIndustries = true;
        entityObj.allJobRequisitionTitleList = true;
        entityObj.allclientOrBU = true;
        entityObj.allBusOfClient = true;
        entityObj.requisitionCategory = false;
        entityObj.requisitionCategoryList = [];
        if (this.companyType === this.MESSAGECONSTANTS.COMPANY_TYPES.STAFFING) {
            entityObj.requisitionCategoryList[0] = {};
            entityObj.requisitionCategoryList[0].name = 'Retained';
            entityObj.requisitionCategoryList[0].isSelected = true;
            entityObj.requisitionCategoryList[1] = {};
            entityObj.requisitionCategoryList[1].name = 'Contingent';
            entityObj.requisitionCategoryList[1].isSelected = true;
            entityObj.requisitionCategoryList[2] = {};
            entityObj.requisitionCategoryList[2].name = 'Both';
            entityObj.requisitionCategoryList[2].isSelected = true;
        }
        else if (this.companyType === this.MESSAGECONSTANTS.COMPANY_TYPES.CORPORATE) {
            entityObj.requisitionCategoryList[0] = {};
            entityObj.requisitionCategoryList[0].name = 'Retained';
            entityObj.requisitionCategoryList[0].isSelected = true;
            entityObj.requisitionCategoryList[1] = {};
            entityObj.requisitionCategoryList[1].name = 'Contingent';
            entityObj.requisitionCategoryList[1].isSelected = true;
            entityObj.requisitionCategoryList[2] = {};
            entityObj.requisitionCategoryList[2].name = 'Both';
            entityObj.requisitionCategoryList[2].isSelected = true;
        }
        return entityObj;
    }
    _parseRoleScopeDetails() {
        // if (this.userProfile.userScopeDetails.allclientOrBU) {
        // angular.forEach(this.userProfile.userScopeDetails.clientOrBUList[0], function(client, key) {
        //     client.selected = true;   
        // });
        // }
        // this.isClientListAndBuAll = this.isStaffingCompany && this.userProfile.userScopeDetails.allBusOfClient && !this.userProfile.userScopeDetails.allclientOrBU? true: false; 
        this.showClientList = !this.userProfile.userScopeDetails.allclientOrBU || (this.userProfile.userScopeDetails.allclientOrBU && !this.userProfile.userScopeDetails.userClientBUinfo.hasAllBuOrClientEnabledForParent) ? true : false;
        this.showBuList = !this.userProfile.userScopeDetails.allBusOfClient || (this.userProfile.userScopeDetails.allBusOfClient && !this.userProfile.userScopeDetails.userClientBUinfo.hasAllBuOfClientEnabledForParent) ? true : false;
    }
    _getUserProfileInfo(successCallback) {
        var user = { userId: this.$stateParams.userId };
        this.utilityService.getUserProfile(user).then((data) => {
            this.userObject = data;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _getAddressDetails(zipcode, type, callback) {
        this.validzipcode = true;
        var locations = [];
        console.log('zipcode : ' + zipcode);
        if (type != 'copycomanyaddress') {
            document.getElementById("copyCompanyAddress").checked = false;
        }
        this.copyCompanyAddress = false;
        var url = 'maps.googleapis.com/maps/api/geocode/json?address=' + zipcode + '&key=' + this.MESSAGECONSTANTS.GEOCODING.API_KEY;
        if (angular.isDefined(zipcode) && !angular.equals(zipcode, '')) {
            $.getJSON({
                url: 'https://maps.googleapis.com/maps/api/geocode/json?address=' + zipcode + '&key=' + this.MESSAGECONSTANTS.GEOCODING.API_KEY,
                data: {
                    sensor: false,
                },
                success: (data, textStatus) => {
                    var createGeoLocation = (addressdetails, postalname) => {
                        var addressobj = {};
                        for (var p = 0; p < addressdetails.address_components.length; p++) {
                            for (var t = 0; t < addressdetails.address_components[p].types.length; t++) {
                                switch (addressdetails.address_components[p].types[t]) {
                                    case 'country':
                                        addressobj.country = addressdetails.address_components[p].long_name;
                                        addressobj.countryCode = addressdetails.address_components[p].short_name;
                                        break;
                                    case 'administrative_area_level_2':
                                        addressobj.county = addressdetails.address_components[p].long_name;
                                        break;
                                    case 'administrative_area_level_1':
                                        addressobj.state = addressdetails.address_components[p].long_name;
                                        break;
                                    case 'locality':
                                        if (angular.isDefined(postalname) && postalname !== '') {
                                            addressobj.city = postalname;
                                        }
                                        else {
                                            addressobj.city = addressdetails.address_components[p].long_name;
                                        }
                                        break;
                                    default:
                                        break;
                                }
                            }
                        }
                        if ((angular.isUndefined(addressobj.city) || angular.isUndefined(addressobj.state) || angular.isUndefined(addressobj.country))) {
                            for (var p = 0; p < addressdetails.address_components.length; p++) {
                                for (var t = 0; t < addressdetails.address_components[p].types.length; t++) {
                                    switch (addressdetails.address_components[p].types[t]) {
                                        case 'locality':
                                            if (angular.isUndefined(addressobj.state)) {
                                                addressobj.state = addressdetails.address_components[p].long_name;
                                            }
                                            if (angular.isUndefined(addressobj.country)) {
                                                addressobj.country = addressdetails.address_components[p].long_name;
                                                addressobj.countryCode = addressdetails.address_components[p].short_name;
                                            }
                                            break;
                                        case 'administrative_area_level_2':
                                            if (angular.isUndefined(addressobj.city)) {
                                                if (angular.isDefined(postalname) && postalname !== '') {
                                                    addressobj.city = postalname;
                                                }
                                                else {
                                                    addressobj.city = addressdetails.address_components[p].long_name;
                                                }
                                            }
                                            if (angular.isUndefined(addressobj.state)) {
                                                addressobj.state = addressdetails.address_components[p].long_name;
                                            }
                                            if (angular.isUndefined(addressobj.country)) {
                                                addressobj.country = addressdetails.address_components[p].long_name;
                                                addressobj.countryCode = addressdetails.address_components[p].short_name;
                                            }
                                            break;
                                        case 'administrative_area_level_3':
                                            if (angular.isUndefined(addressobj.city)) {
                                                if (angular.isDefined(postalname) && postalname !== '') {
                                                    addressobj.city = postalname;
                                                }
                                                else {
                                                    addressobj.city = addressdetails.address_components[p].long_name;
                                                }
                                            }
                                            break;
                                        case 'administrative_area_level_4':
                                            if (angular.isUndefined(addressobj.city)) {
                                                if (angular.isDefined(postalname) && postalname !== '') {
                                                    addressobj.city = postalname;
                                                }
                                                else {
                                                    addressobj.city = addressdetails.address_components[p].long_name;
                                                }
                                            }
                                            break;
                                        case 'sublocality' || 'sublocality_level_1' || 'sublocality_level_5':
                                            if (angular.isDefined(postalname) && postalname !== '') {
                                                addressobj.city = postalname;
                                            }
                                            else {
                                                addressobj.city = addressdetails.address_components[p].long_name;
                                            }
                                            break;
                                        case 'administrative_area_level_1':
                                            if (angular.isUndefined(addressobj.city)) {
                                                if (angular.isDefined(postalname) && postalname !== '') {
                                                    addressobj.city = postalname;
                                                }
                                                else {
                                                    addressobj.city = addressdetails.address_components[p].long_name;
                                                }
                                                if (angular.isUndefined(addressobj.country)) {
                                                    addressobj.country = addressdetails.address_components[p].long_name;
                                                    addressobj.countryCode = addressdetails.address_components[p].short_name;
                                                }
                                            }
                                            break;
                                    }
                                }
                            }
                        }
                        if (angular.isUndefined(addressobj.county)) {
                            addressobj.county = null;
                        }
                        return addressobj;
                    };
                    var checkCountyExists = (locations, profile) => {
                        for (let i = 0; i < locations.length; i++) {
                            if (angular.equals(locations[i].city, profile.userDetails.city) &&
                                angular.isDefined(locations[i].county) && (locations.county !== null) &&
                                angular.isDefined(profile.userDetails.county) &&
                                (profile.userDetails.county !== null) && angular.equals(locations[i].county, profile.userDetails.county)) {
                                return true;
                            }
                        }
                        return false;
                    };
                    if (data.status === 'OK') {
                        console.log('data.status OK');
                        this.validzipcode = true;
                        for (let i = 0; i < data.results.length; i++) {
                            if (angular.isDefined(data.results[i].postcode_localities) && (data.results[i].postcode_localities.length > 0)) {
                                for (let k = 0; k < data.results[i].postcode_localities.length; k++) {
                                    if ((data.results[i].types[0] === 'postal_code')) {
                                        var location = createGeoLocation(data.results[i], data.results[i].postcode_localities[k]);
                                        locations.push(angular.copy(location));
                                    }
                                }
                            }
                            else {
                                if ((data.results[i].types[0] === 'postal_code')) {
                                    var location = createGeoLocation(data.results[i]);
                                    locations.push(angular.copy(location));
                                }
                            }
                        }
                        if ((type === 'zipchanged') && !this.cancelClicked && locations.length) {
                            console.log('zipchanged && !this.cancelClicked && locations.length');
                            this.userProfile.userDetails.city = locations[0].city;
                            this.userProfile.userDetails.state = locations[0].state;
                            this.userProfile.userDetails.county = locations[0].county;
                            if (angular.isDefined(locations[0].county) && (locations[0].county !== null)) {
                                this.isCountyExists = true;
                            }
                            else {
                                this.isCountyExists = false;
                            }
                            this.userProfile.userDetails.country = locations[0].country;
                            this.countryCodeForTelephone = locations[0].countryCode;
                            this.countryCodeForTelephone = locations[0].countryCode;
                            this._setWorkTelephoneCountryCode();
                            this._setMobileNumberCountryCode();
                            this.zipCodeCallCompleted = true;
                        }
                        else if ((type === 'copycomanyaddress') && !this.cancelClicked && locations.length) {
                            console.log('copycomanyaddress && !this.cancelClicked && locations.length');
                            this.userProfile.userDetails.city = locations[0].city;
                            this.userProfile.userDetails.state = locations[0].state;
                            this.userProfile.userDetails.county = locations[0].county;
                            if (angular.isDefined(locations[0].county) && (locations[0].county !== null)) {
                                this.isCountyExists = true;
                            }
                            else {
                                this.isCountyExists = false;
                            }
                            this.userProfile.userDetails.country = locations[0].country;
                            this.countryCodeForTelephone = locations[0].countryCode;
                            this.countryCodeForTelephone = locations[0].countryCode;
                            this._setWorkTelephoneCountryCode();
                            this._setMobileNumberCountryCode();
                            this.zipCodeCallCompleted = true;
                        }
                        else if (this.cancelClicked) {
                            locations = angular.copy(this.copyOfGeoLocationsCopy);
                            this.geoLocations = angular.copy(this.copyOfGeoLocationsCopy);
                            console.log('in this.cancelClicked this.geoLocations :' + angular.toJson(locations));
                            this.userProfile.userDetails.city = this.userProfileReset.userDetails.city;
                            this.userProfile.userDetails.state = this.userProfileReset.userDetails.state;
                            this.userProfile.userDetails.county = this.userProfileReset.userDetails.county;
                            if (checkCountyExists(angular.copy(locations), angular.copy(this.userProfileReset))) {
                                this.isCountyExists = true;
                            }
                            else {
                                this.isCountyExists = false;
                            }
                            this.userProfile.userDetails.country = this.userProfileReset.userDetails.country;
                            this.zipCodeCallCompleted = true;
                        }
                        else if (locations.length) {
                            console.log('locations.length with locations : ' + angular.toJson(locations));
                            console.log('this.userProfileReset.userDetails : ' + angular.toJson(this.userProfileReset.userDetails));
                            if (checkCountyExists(angular.copy(locations), angular.copy(this.userProfileReset))) {
                                this.isCountyExists = true;
                            }
                            else {
                                this.isCountyExists = false;
                            }
                            if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
                                /**
                                 * enters when clicked on cancel in create flow
                                 */
                                this.userProfile.userDetails.workTelephone = angular.copy(this.userProfileReset.userDetails.workTelephone);
                                this.userProfile.userDetails.mobileNumber = angular.copy(this.userProfileReset.userDetails.mobileNumber);
                            }
                            else if ((this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) || (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.VIEW)) {
                                /**
                                 * enters when starting of update flow
                                 */
                                this.userProfile.userDetails.workTelephone = angular.copy(this.userObject.userDetails.workTelephone);
                                this.userProfile.userDetails.mobileNumber = angular.copy(this.userObject.userDetails.mobileNumber);
                            }
                            this.zipCodeCallCompleted = true;
                        }
                    }
                    else {
                        console.log('else');
                        if (!this.cancelClicked) {
                            console.log('!this.cancelClicked');
                            this.validzipcode = false;
                            locations = [];
                            this.geoLocations = [];
                            this.userProfile.userDetails.city = '';
                            this.userProfile.userDetails.state = '';
                            this.userProfile.userDetails.county = '';
                            this.isCountyExists = false;
                            this.userProfile.userDetails.country = '';
                            this.zipCodeCallCompleted = true;
                        }
                        else {
                            console.log('!this.cancelClicked else');
                            locations = angular.copy(this.copyOfGeoLocationsCopy);
                            this.geoLocations = angular.copy(this.copyOfGeoLocationsCopy);
                            this.userProfile.userDetails.city = this.userProfileReset.userDetails.city;
                            this.userProfile.userDetails.state = this.userProfileReset.userDetails.state;
                            this.userProfile.userDetails.county = this.userProfileReset.userDetails.county;
                            if (checkCountyExists(angular.copy(locations), angular.copy(this.userProfileReset))) {
                                this.isCountyExists = true;
                            }
                            else {
                                this.isCountyExists = false;
                            }
                            this.userProfile.userDetails.country = this.userProfileReset.userDetails.country;
                            this.zipCodeCallCompleted = true;
                        }
                    }
                    this.geoLocations = angular.copy(locations);
                    if (!this.geoLocations.length) {
                        console.log('!this.geoLocations.length');
                        this.validzipcode = false;
                        this.userProfile.userDetails.city = '';
                        this.userProfile.userDetails.state = '';
                        this.userProfile.userDetails.county = '';
                        this.isCountyExists = false;
                        this.userProfile.userDetails.country = '';
                        this.zipCodeCallCompleted = true;
                    }
                    console.log('this.geoLocations : ' + angular.toJson(this.geoLocations));
                    this.$scope.$apply();
                    if (type === 'start') {
                        // this.form.userDetailsForm.$setPristine();
                    }
                    if (typeof callback != "undefined") {
                        return callback(this.geoLocations);
                    }
                },
                error: (data) => {
                    this.validzipcode = false;
                    this.geoLocations = [];
                    this.isCountyExists = false;
                    if (typeof callback != "undefined") {
                        return callback('success');
                    }
                }
            });
        }
        else {
            this.geoLocations = [];
            this.isCountyExists = false;
            if (typeof callback != "undefined") {
                return callback('success');
            }
        }
    }
    /**
     * This method gets all managers list while demoting company admin and assign to scope variable
     * @access for update
     */
    _getManagerListWhileDemotingAdmin(userId) {
        let buId = null;
        if (this.isCorporateFlag && !_.isNull(this.userProfile.buId) && this.userProfile.buId !== "" && this.userProfile.buId !== undefined) {
            buId = this.userProfile.buId;
        }
        this.userService.getManagersWhileDemotingAdmin(userId, this.$rootScope.userDetails.company.companyId, this.userProfile.userDetails.role.id, buId, (data) => {
            if (data.length === 0) {
                this.alertsAndNotificationsService.showBannerMessage('Cannot change the role of the only existing Admin !', 'danger');
                this.userProfile.userDetails.role = angular.copy(this.userProfileReset.userDetails.role);
                this.form.userScopeDetailsform.$setPristine();
            }
            else {
                this.managerList = data;
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            console.log('error : ' + angular.toJson(error));
        });
    }
    // var assignOrChangeManager = function (managerid, userid) {
    //     genericService.addObject(this.USERMANAGEMENTCONSTANTS.CONTROLLER.ASSIGN_MANAGER + '/' + managerid + '/' + userid).then(function (data) {
    //         this.userProfile.userDetails.manager = angular.copy(data.userDetails.manager);
    //         if (!angular.equals(this.userProfile.userDetails.manager, null) && !angular.equals(this.userProfile.userDetails.manager.lastName, null)) {
    //             this.userProfile.userDetails.manager.firstName = this.userProfile.userDetails.manager.firstName + ' ' + this.userProfile.userDetails.manager.lastName;
    //         }
    //         this.userProfileReset = angular.copy(this.userProfile);
    //         this.form.userDetailsForm.$setPristine();
    //     }, function (error) {
    //     	if(this.$rootScope.isOnline){
    //         	this.alertsAndNotificationsService.showBannerMessage(error.message,'danger');
    //         }
    //         this.userProfile.userDetails.manager = angular.copy(this.userProfileReset.userDetails.manager);
    //     });
    // };
    /**
     * This method helps to go to next step by checking
     * what are all the data needed for next step
     * @access for only view access
     */
    getNextStepData() {
        if (this.triggerCount === 0) {
            this.nextButtonClicked = false;
            this.saveButtonClicked = false;
            this.triggerCount = angular.copy(this.triggerCount + 1);
            this.currentstep = this._getCurrentStep();
            this.StorageService.remove('wizardoperations');
            if (this.currentstep === 1) {
                this._getEntityScopeDetails();
            }
            else if (this.currentstep === 2) {
                this.triggerCount = 0;
                this.$timeout(() => {
                    this.StorageService.remove('wizardoperations');
                    if (angular.copy(this.$stateParams.purpose) !== null) {
                        this.$state.go('missioncontrol.dashboard', null, { reload: true });
                    }
                    else {
                        this._goToUsersPage();
                    }
                }, 500);
            }
        }
    }
    _getCurrentStep() {
        return $('#myWizard').wizard('selectedItem').step;
    }
    /**
     * This method gets all entity scope datails
     * based on company type.
     * Assign to scope variable and finally when leaving
     * from step assign values to userProfile object.
     * @access for only create. No need for view and edit access as
     * details will be a part of user object
     */
    _getEntityScopeDetails() {
        this.StorageService.remove('wizardoperations');
        if (this.isInHost) {
            this._getESfor4dot5Admin();
        }
        else if (this.isFourDotFiveAdmin(this.userProfile.userDetails.role)) {
            this.userProfile.userScopeDetails = this._createEntityScopeForAdmin();
            this.userProfileReset.userScopeDetails = angular.copy(this.userProfile.userScopeDetails);
            this.lastStep = true;
            this.nextButtonClicked = false;
            this.saveButtonClicked = false;
            this.StorageService.set('wizardoperations', true);
            this.stepTrigger('nextbtnclick');
        }
        else {
            // if((this.userProfile.userScopeDetails === null) || (this.roleChanged) || (this.managerChanged) || (this.isUserBelongsToBUChanged)){
            this.utilityService.getUserRoleEntityScope(angular.copy(this.userProfile)).then((data) => {
                this.userProfile.userScopeDetails = data;
                this._parseRoleScopeDetails();
                this.userProfileReset.userScopeDetails = angular.copy(this.userProfile.userScopeDetails);
                this.StorageService.set('wizardoperations', true);
                this.stepTrigger('nextbtnclick');
            }, (error) => {
                if (this.$rootScope.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
                console.log('error');
            });
            // }else{
            //     this.StorageService.set('wizardoperations', true);
            //     this.stepTrigger('nextbtnclick');
            // }
        }
    }
    /**
     * This method will be called whenever user clicked on 'NEXT' buttton
     * This method checks whether any changes are made in UI with respective steps
     */
    manageStepData() {
        if (this.triggerCount === 0) {
            this.StorageService.remove('wizardoperations');
            this.triggerCount = angular.copy(this.triggerCount + 1);
            this.formSubmitted = true;
            this.nextButtonClicked = true;
            this.saveButtonClicked = false;
            this.valid = false;
            var currentStep = this._getCurrentStep();
            switch (currentStep) {
                case 1:
                    this.valid = this.form.userDetailsForm.$valid && !this.utilityService.isContentinObjSame(this.userProfile.userDetails.address1, this.userProfile.userDetails.address2) && this.isValidMobileNumberEntered && this.isValidWorkTelephoneEntered && (!this.zipCodeCalling || (this.zipCodeCalling && this.zipCodeCallCompleted));
                    // no check for step data change as save is to be called to handle "User belongs to BU" where Bu has to be preselected in the scope
                    if (this.valid && this.accessMode !== this.MESSAGECONSTANTS.ACCESS_MODES.VIEW && this._hasStepDataChanged(currentStep)) {
                        this.lastStep = false;
                        if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
                            var url = this.USERMANAGEMENTCONSTANTS.CONTROLLER.SAVE_USER + '/' + this.$rootScope.userDetails.company.companyId;
                        }
                        else if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
                            var url = this.USERMANAGEMENTCONSTANTS.CONTROLLER.UPDATE_USER + '/' + this.$rootScope.userDetails.company.companyId;
                        }
                        this._manageUserDetails(url);
                    }
                    else if (this.valid) {
                        this._getEntityScopeDetails();
                    }
                    else {
                        this.form.userDetailsForm.workTelephone.visited = true;
                        this.form.userDetailsForm.mobileNumber.visited = true;
                        this.triggerCount = 0;
                    }
                    break;
                case 2:
                    this.valid = this.form.userDetailsForm.$valid && this.form.userScopeDetailsform.$valid && this.isValidMobileNumberEntered && this.isValidWorkTelephoneEntered;
                    if (this.valid && !this._hasStepDataChanged(currentStep)) {
                        if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
                            if (!this.userCreated) {
                                this.userCreated = true;
                                if ((this.nextButtonFlag > 0) && (this.recentButtonClick === 'nextButton')) {
                                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.USER.CREATESUCCESS, 'success');
                                }
                            }
                            else {
                                if ((this.nextButtonFlag > 0) && (this.recentButtonClick === 'nextButton')) {
                                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.USER.SAVESUCCESS, 'success');
                                }
                            }
                            this.managerDetails.firstName = this.managerDetails.firstName.split(" ")[0];
                            var managerReturnObj = this.managerDetails;
                        }
                        else {
                            if ((this.nextButtonFlag > 0) && (this.recentButtonClick === 'nextButton')) {
                                this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.USER.UPDATESUCCESS, 'success');
                            }
                            else {
                                this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.NOTHING_UPDATED + " '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' ", 'success');
                            }
                            var managerReturnObj = this.originalManagerObj;
                        }
                        this.$timeout(() => {
                            this.StorageService.remove('wizardoperations');
                            if (angular.copy(this.$stateParams.purpose) !== null) {
                                this.$state.go('missioncontrol.dashboard', null, { reload: true });
                            }
                            else {
                                this.$state.go('missioncontrol.teamMembers', { managerObj: managerReturnObj }, { reload: false });
                            }
                        }, 500);
                    }
                    else if (this.valid) {
                        this._manageUserScopeDetails();
                    }
                    else {
                        this.triggerCount = 0;
                    }
                    break;
                default:
                    this.text = "Something went wrong";
            }
        }
    }
    _hasStepDataChanged(stepno) {
        switch (stepno) {
            case 1: return !angular.equals(this.userProfile, this.userProfileReset) && this.form.userDetailsForm.$dirty;
            case 2: return !angular.equals(this.userProfile.userScopeDetails, this.userProfileReset.userScopeDetails);
            default: this.alertsAndNotificationsService.showBannerMessage('Something went wrong.. Please contact system admin.', 'danger');
        }
    }
    /**
     * This method will be called from manageStepData() if some thing is changed on ui in step1;
     * This method deals with saving of user step1 details and assigning manager for saved user.
     * @access to CREATE MODE and EDIT MODE when clicked on 'NEXT' Button
     */
    _manageUserDetails(url) {
        var roleOrManagerChangeCheck = (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) ||
            ((this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) && ((this.nextButtonFlag > 0) || (this.saveButtonFlag > 0)));
        if (roleOrManagerChangeCheck) {
            this._getChangesForRoleAndManager();
        }
        this.utilityService.saveUserProfileObject(url, angular.copy(this.userProfile)).then((data) => {
            this.formSubmitted = false;
            this.userProfile = data;
            this.nextButtonFlag++;
            this.recentButtonClick = 'nextButton';
            this.nextButtonClicked = false;
            this._showUserDetailsSaveMessage('next');
            this.geoLocationsCopy = angular.copy(this.geoLocations);
            this.userProfileReset = angular.copy(this.userProfile);
            this.form.userDetailsForm.$setPristine();
            this._getEntityScopeDetails();
        }, (error) => {
            this.triggerCount = 0;
            this.formSubmitted = false;
            if (error.statusCode === '410') {
                if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
                    if (angular.isDefined(this.managerDetails) && !angular.equals(this.managerDetails, null) && !angular.equals(this.managerDetails.lastName, null)) {
                        this.managerDetails.firstName = this.managerDetails.firstName.split(" ")[0];
                    }
                    var managerReturnObj = this.managerDetails;
                }
                else if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
                    var managerReturnObj = this.originalManagerObj;
                }
                this.StorageService.remove('wizardoperations');
                if (angular.copy(this.$stateParams.purpose) !== null) {
                    this.$state.go('missioncontrol.dashboard', null, { reload: true });
                }
                else {
                    this.$state.go('missioncontrol.teamMembers', { managerObj: managerReturnObj }, { reload: false });
                }
            }
            else {
                if (this.$rootScope.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
                if (this._isRoleExistsforUser() && this._isManagerExistsforUser()) {
                    this.userProfile.userDetails = angular.copy(this.userProfileReset.userDetails);
                }
            }
        });
    }
    _isRoleExistsforUser() {
        return angular.isDefined(this.userProfile.userDetails) && angular.isDefined(this.userProfileReset.userDetails) &&
            (this.userProfile.userDetails !== null) && (this.userProfileReset.userDetails !== null) &&
            angular.isDefined(this.userProfile.userDetails.role) && angular.isDefined(this.userProfileReset.userDetails.role) &&
            (this.userProfile.userDetails.role !== null) && (this.userProfileReset.userDetails.role !== null);
    }
    _isManagerExistsforUser() {
        return this._isRoleExistsforUser() &&
            angular.isDefined(this.userProfile.userDetails.manager) && angular.isDefined(this.userProfileReset.userDetails.manager);
    }
    _getChangesForRoleAndManager() {
        if (!angular.equals(this.userProfile.userDetails.role, this.userProfileReset.userDetails.role)) {
            this.roleChanged = true;
            this.oldRole = angular.copy(this.userProfileReset.userDetails.role);
        }
        else {
            this.roleChanged = false;
            this.oldRole = null;
        }
        if (!angular.equals(this.userProfile.userDetails.manager, this.userProfileReset.userDetails.manager)) {
            this.managerChanged = true;
            this.oldManager = angular.copy(this.userProfileReset.userDetails.manager);
        }
        else {
            this.managerChanged = false;
            this.oldManager = null;
        }
    }
    _showUserDetailsSaveMessage(buttonclicked) {
        var userDetailsSaveMessageCheck = (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) ||
            ((this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) && ((this.nextButtonFlag > 0) || (this.saveButtonFlag > 0)));
        if (userDetailsSaveMessageCheck) {
            if (this.roleChanged && this.managerChanged) {
                if (this.isCompanyAdmin(this.userProfileReset.userDetails.role)) {
                    var successmessage = "The role for the user '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' was successfully changed from '<b><i class='wrap-word'>" + this.oldRole.description + "</i></b>' to '<b><i class='wrap-word'>" + this.userProfile.userDetails.role.description + "</i></b>' <br> " +
                        "The manager of the user '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' has been set to '<b><i class='wrap-word'>" +
                        this.getFullName(this.userProfile.userDetails.manager.firstName, null) + "</i></b>'.";
                }
                else {
                    var successmessage = "The role for the user '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' was successfully changed from '<b><i class='wrap-word'>" + this.oldRole.description + "</i></b>' to '<b><i class='wrap-word'>" + this.userProfile.userDetails.role.description + "</i></b>' <br> " +
                        "The manager of the user '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' was changed from '<b><i class='wrap-word'>" +
                        this.getFullName(this.oldManager.firstName, null) + "</i></b>' to '<b><i class='wrap-word'>" +
                        this.getFullName(this.userProfile.userDetails.manager.firstName, null) + "</i></b>'.";
                }
                this.alertsAndNotificationsService.showBannerMessage(successmessage, 'success');
            }
            else if (this.roleChanged) {
                var successmessage = "The role for the user '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' was successfully changed from '<b><i class='wrap-word'>" + this.oldRole.description + "</i></b>' to '<b><i class='wrap-word'>" + this.userProfile.userDetails.role.description + "'.";
                this.alertsAndNotificationsService.showBannerMessage(successmessage, 'success');
            }
            else if (this.managerChanged) {
                var successmessage = "The manager of the user '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' was changed from '<b><i class='wrap-word'>" +
                    this.getFullName(this.oldManager.firstName, null) + "</i></b>' to '<b><i class='wrap-word'>" +
                    this.getFullName(this.userProfile.userDetails.manager.firstName, null) + "</i></b>'.";
                this.alertsAndNotificationsService.showBannerMessage(successmessage, 'success');
            }
            else if (buttonclicked === 'save') {
                if ((this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE)) {
                    if (this.userCreated) {
                        this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.USER.SAVESUCCESS, 'success');
                    }
                    else {
                        this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.USER.CREATESUCCESS, 'success');
                    }
                }
                else {
                    if (this.isLoggedInUser(this.userProfile.userDetails)) {
                        this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.OWN_PROFILE_UPDATE, 'success');
                    }
                    else {
                        this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.USER.UPDATESUCCESS, 'success');
                    }
                }
            }
        }
    }
    /**
     * This method will be called from manageStepData() if some thing is changed on ui in step2;
     * This method deals with saving of user step2 details.
     * @access to CREATE MODE and EDIT MODE when clicked on 'NEXT' Button
     */
    _manageUserScopeDetails() {
        //this.userProfileReset.userScopeDetails = angular.copy(this.userProfile.userScopeDetails);
        this.utilityService.setUserRoleEntityScope(angular.copy(this.userProfile)).then((data) => {
            this.userProfile = data;
            this.nextButtonFlag++;
            this.recentButtonClick = 'nextButton';
            this.nextButtonClicked = false;
            this.userProfileReset = angular.copy(this.userProfile);
            this.form.userScopeDetailsform.$setPristine();
            if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
                if (!this.userCreated) {
                    this.userCreated = true;
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.USER.CREATESUCCESS, 'success');
                }
                else {
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.USER.SAVESUCCESS, 'success');
                }
                this.managerDetails.firstName = this.managerDetails.firstName.split(" ")[0];
                var managerReturnObj = this.managerDetails;
            }
            else {
                if (angular.copy(this.$stateParams.purpose) !== null) {
                    this.StorageService.remove('wizardoperations');
                    this.$state.go('missioncontrol.dashboard', null, { reload: true });
                }
                else {
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.USER.UPDATESUCCESS, 'success');
                    var managerReturnObj = this.originalManagerObj;
                }
            }
            this.StorageService.remove('wizardoperations');
            this.$state.go('missioncontrol.teamMembers', { managerObj: managerReturnObj }, { reload: false });
            this.userService.userCache(null, () => { }, () => { });
        }, (error) => {
            this.triggerCount = 0;
            this.formSubmitted = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            this.userProfile.userScopeDetails = angular.copy(this.userProfileReset.userScopeDetails);
        });
    }
    /**
     * This method will be called whenever user clicked on 'SAVE' buttton
     * This method checks whether any changes are made in UI with respective steps
     */
    saveStepData() {
        this.formSubmitted = true;
        this.nextButtonClicked = false;
        this.saveButtonClicked = true;
        this.valid = false;
        var currentStep = this._getCurrentStep();
        switch (currentStep) {
            case 1:
                //Cheking mobile and telephone validations also.
                this.valid = this.form.userDetailsForm.$valid && !this.utilityService.isContentinObjSame(this.userProfile.userDetails.address1, this.userProfile.userDetails.address2) && this.isValidMobileNumberEntered && this.isValidWorkTelephoneEntered && (!this.zipCodeCalling || (this.zipCodeCalling && this.zipCodeCallCompleted));
                if (this.valid && !this._hasStepDataChanged(currentStep)) {
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.NOTHING_TO_SAVE, 'success');
                    this.formSubmitted = false;
                    this.saveButtonClicked = false;
                }
                else if (this.valid) {
                    if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
                        var url = this.USERMANAGEMENTCONSTANTS.CONTROLLER.SAVE_USER + '/' + this.$rootScope.userDetails.company.companyId;
                    }
                    else if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
                        var url = this.USERMANAGEMENTCONSTANTS.CONTROLLER.UPDATE_USER + '/' + this.$rootScope.userDetails.company.companyId;
                    }
                    this._saveUserDetails(url);
                }
                else {
                    this.form.userDetailsForm.workTelephone.visited = true;
                    this.form.userDetailsForm.mobileNumber.visited = true;
                }
                break;
            case 2:
                this.valid = this.form.userDetailsForm.$valid && this.form.userScopeDetailsform.$valid && this.isValidMobileNumberEntered && this.isValidWorkTelephoneEntered;
                if (this.valid && !this._hasStepDataChanged(currentStep)) {
                    this.formSubmitted = false;
                    this.saveButtonClicked = false;
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.NOTHING_TO_SAVE, 'success');
                }
                else if (this.valid) {
                    this._saveUserScopeDetails();
                }
                break;
            default:
                this.text = "Something went wrong";
        }
    }
    /**
     * This method will be called from saveStepData() if some thing is changed on ui in step1;
     * This method deals with saving of user step1 details and assigning manager for saved user.
     * @access to CREATE MODE and EDIT MODE when clicked on 'SAVE' Button
     */
    _saveUserDetails(url) {
        var roleOrManagerChangeCheck = (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) ||
            ((this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) && ((this.nextButtonFlag > 0) || (this.saveButtonFlag > 0)));
        if (roleOrManagerChangeCheck) {
            this._getChangesForRoleAndManager();
        }
        this.utilityService.saveUserProfileObject(url, angular.copy(this.userProfile)).then((data) => {
            this.formSubmitted = false;
            this.userProfile = data;
            this.saveButtonFlag++;
            this.recentButtonClick = 'saveButton';
            this.saveButtonClicked = false;
            this._showUserDetailsSaveMessage('save');
            this.geoLocationsCopy = angular.copy(this.geoLocations);
            this.userProfileReset = angular.copy(this.userProfile);
            if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
                this.userCreated = true;
            }
            else {
                this.userCreated = false;
            }
            this.form.userDetailsForm.$setPristine();
        }, (error) => {
            this.triggerCount = 0;
            this.formSubmitted = false;
            if (error.statusCode === '410') {
                if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
                    if (angular.isDefined(this.managerDetails) && !angular.equals(this.managerDetails, null) && !angular.equals(this.managerDetails.lastName, null)) {
                        this.managerDetails.firstName = this.managerDetails.firstName.split(" ")[0];
                    }
                    var managerReturnObj = this.managerDetails;
                }
                else if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
                    var managerReturnObj = this.originalManagerObj;
                }
                this.StorageService.remove('wizardoperations');
                if (angular.copy(this.$stateParams.purpose) !== null) {
                    this.$state.go('missioncontrol.dashboard', null, { reload: true });
                }
                else {
                    this.$state.go('missioncontrol.teamMembers', { managerObj: managerReturnObj }, { reload: false });
                }
            }
            else {
                if (this.$rootScope.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
                if (this._isRoleExistsforUser() && this._isManagerExistsforUser()) {
                    this.userProfile.userDetails = angular.copy(this.userProfileReset.userDetails);
                }
            }
        });
    }
    /**
     * This method will be called from saveStepData() if some thing is changed on ui in step2;
     * This method deals with saving of user step2 details.
     * @access to CREATE MODE and EDIT MODE when clicked on 'SAVE' Button
     */
    _saveUserScopeDetails(url) {
        //this.userProfileReset.userScopeDetails = angular.copy(this.userProfile.userScopeDetails);
        this.utilityService.setUserRoleEntityScope(angular.copy(this.userProfile)).then((data) => {
            this.userProfile = angular.copy(data);
            this.saveButtonFlag++;
            this.recentButtonClick = 'saveButton';
            this.saveButtonClicked = false;
            this.userProfileReset = angular.copy(this.userProfile);
            this.form.userScopeDetailsform.$setPristine();
            if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
                if (this.isLoggedInUser(this.userProfile.userDetails)) {
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.OWN_PROFILE_UPDATE, 'success');
                }
                else {
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.USER.UPDATESUCCESS, 'success');
                }
            }
            else {
                this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.USER.SAVESUCCESS, 'success');
            }
            this.roleChanged = false;
            this.managerChanged = false;
            this.userService.userCache(null, () => { }, () => { });
        }, (error) => {
            this.triggerCount = 0;
            this.formSubmitted = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            this.userProfile.userScopeDetails = angular.copy(this.userProfileReset.userScopeDetails);
        });
    }
    /**
     * This method is called, when user clicked on 'PREV' button
     * This will take care of changes to be made to 'userProfile' object when step changes
     */
    prevStepClicked() {
        this.saveButtonClicked = false;
        this.nextButtonClicked = false;
        var currentStep = this._getCurrentStep();
        switch (currentStep) {
            case 1:
                break;
            case 2:
                this.StorageService.set('wizardoperations', true);
                this.lastStep = false;
                break;
            default:
                this.text = "Something went wrong";
        }
    }
    /**
     * This method is called when user clicks on
     * cancel button.
     * This method works according to access permissions
     * of user when he enters into this module.
     * @access for create, view and update
     */
    cancel() {
        var currentStep = this._getCurrentStep();
        if (this._hasStepDataChanged(currentStep)) {
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
                message: "Unsaved data on the page will be lost. Do you still want to continue?",
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: (result) => {
                    if (result) {
                        this.clearData();
                        this._goToUsersPage();
                    }
                    else {
                        this.showConfirmationPopup = false;
                        this.$rootScope.switchClicked = false;
                    }
                }
            });
        }
        else {
            this._goToUsersPage();
        }
    }
    _goToUsersPage() {
        var managers = this.StorageService.get('managers');
        if (!_.isNull(managers) && managers !== undefined && managers.length > 0) {
            this.$state.go('missioncontrol.teamMembers', { managerObj: managers[managers.length - 1] }, { reload: false });
        }
        else {
            this.$state.go('missioncontrol.teamMembers', { reload: true });
        }
    }
    clearData() {
        this.cancelClicked = false;
        this.saveButtonClicked = false;
        this.nextButtonClicked = false;
        this.copyOfGeoLocations = angular.copy(this.geoLocations);
        this.copyOfGeoLocationsCopy = angular.copy(this.geoLocationsCopy);
        var currentStep = this._getCurrentStep();
        this.showConfirmationPopup = false;
        this.$rootScope.switchClicked = false;
        switch (currentStep) {
            case 1:
                if (this._hasStepDataChanged(currentStep)) {
                    this.cancelClicked = true;
                    this.formSubmitted = false;
                    if (!angular.equals(this.userProfile.userDetails.zipcode, this.userProfileReset.userDetails.zipcode)) {
                        console.log('getAddressDetails with zipchanged');
                        this._getAddressDetails(this.userProfileReset.userDetails.zipcode, 'zipchanged');
                    }
                    else {
                        console.log('getAddressDetails with start');
                        this._getAddressDetails(this.userProfileReset.userDetails.zipcode, 'start');
                    }
                    this.userProfile = angular.copy(this.userProfileReset);
                    if (!angular.equals(this.userProfile.userDetails, {}) && angular.isDefined(this.userProfile.userDetails.userId) && angular.isDefined(this.userProfile.userDetails.role)) {
                        this._getManagersList(this.userProfile.userDetails.userId, this.userProfile.userDetails.role.id, this.userProfile.buId);
                    }
                    else {
                        this.countryCodeForTelephone = angular.copy(this.$rootScope.defaultCountryCode);
                        this.countryCodeForTelephone = angular.copy(this.$rootScope.defaultCountryCode);
                        this._setWorkTelephoneCountryCode();
                        this._setMobileNumberCountryCode();
                    }
                    if (angular.isDefined(this.userProfileReset.userDetails.workTelephone) && (this.userProfileReset.userDetails.workTelephone !== null)) {
                        document.getElementById("workTelephone").value = this.userProfileReset.userDetails.workTelephone;
                        // this.$scope.safeApply();
                        this._setWorkTelephoneCountryCode();
                    }
                    if (angular.isDefined(this.userProfileReset.userDetails.mobileNumber) && (this.userProfileReset.userDetails.mobileNumber !== null)) {
                        document.getElementById("mobileNumber").value = this.userProfileReset.userDetails.mobileNumber;
                        // this.$scope.safeApply();
                        this._setMobileNumberCountryCode();
                    }
                    this.form.userDetailsForm.$setPristine();
                    console.log('this.isCountyExists : ' + this.isCountyExists);
                }
                else {
                    this.formSubmitted = false;
                    if (angular.equals(this.userProfile.userDetails, {})) {
                        this.countryCodeForTelephone = angular.copy(this.$rootScope.defaultCountryCode);
                        this.countryCodeForTelephone = angular.copy(this.$rootScope.defaultCountryCode);
                        this._setWorkTelephoneCountryCode();
                        this._setMobileNumberCountryCode();
                        this.isValidWorkTelephoneEntered = false;
                        this.isValidMobileNumberEntered = false;
                    }
                    else {
                    }
                    this.form.userDetailsForm.$setPristine();
                }
                angular.element('.companyaddresscopyenabled').attr({ 'readonly': false, 'disabled': false });
                break;
            case 2:
                if (this._hasStepDataChanged(currentStep)) {
                    this.cancelClicked = true;
                    this.formSubmitted = false;
                    this.userProfile = angular.copy(this.userProfileReset);
                    this.form.userScopeDetailsform.$setPristine();
                }
                break;
            default:
                this.cancelClicked = false;
                alert("Something went wrong...Please Logout and try again");
        }
    }
    cancelSteps() {
        this.cancel();
    }
    /**
     * This method is called, when user clicked on 'Step Names' directly
     * This will take care of changes to be made to 'userProfile' object when step changes
     */
    getStepChanges(stepclicked) {
        this.saveButtonClicked = false;
        this.nextButtonClicked = false;
        switch (stepclicked) {
            case 1:
                this.lastStep = false;
                break;
            case 2:
                this.lastStep = true;
                break;
            default:
                this.lastStep = false;
                console.log('something went wrong');
        }
    }
    //form changes
    /**
    * This method will be called when ever role is changed from ui
    */
    changeRoleObject() {
        var roleId = angular.copy(this.userProfile.userDetails.role.id);
        for (let i = 0; i < this.roles.length; i++) {
            if (roleId === this.roles[i].id) {
                this.userProfile.userDetails.role = angular.copy(this.roles[i]);
            }
        }
        var isRoleChangeValid = (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) ||
            ((this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) && ((this.nextButtonFlag > 0) || (this.saveButtonFlag > 0)));
        if (isRoleChangeValid && (this.userProfile.userDetails.role.id !== this.userProfileReset.userDetails.role.id)) {
            if (this.isCompanyAdmin(this.userProfileReset.userDetails.role)) {
                this.userProfile.userDetails.manager = null;
                let buId = null;
                if (this.isCorporateFlag && !_.isNull(this.userProfile.buId) && this.userProfile.buId !== "" && this.userProfile.buId !== undefined) {
                    buId = this.userProfile.buId;
                }
                this.userService.getManagersWhileDemotingAdmin(this.userProfileReset.userDetails.userId, this.$rootScope.userDetails.company.companyId, this.userProfile.userDetails.role.id, buId, (data) => {
                    if (data.length === 0) {
                        this._showRoleChangeAlert('Cannot change the role of the only existing Admin.');
                    }
                    else {
                        this._checkRoleChange();
                    }
                }, (error) => {
                    if (this.$rootScope.isOnline) {
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                });
            }
            else {
                this._checkRoleChange();
            }
        }
        else if (isRoleChangeValid) {
            this._getManagersList(this.userProfile.userDetails.userId, this.userProfile.userDetails.role.id, this.userProfile.buId);
        }
    }
    _checkRoleChange() {
        if (this.isSeniorRecruiter(this.userProfileReset.userDetails.role)) {
            this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
        }
        else if (this.isRecruiter(this.userProfileReset.userDetails.role)) {
            this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
        }
        else if (this.isRecruitingManager(this.userProfileReset.userDetails.role)) {
            if (this.isRecruiter(this.userProfile.userDetails.role) || this.isSeniorRecruiter(this.userProfile.userDetails.role)) {
                if (angular.isDefined(this.userProfileReset.reporteeCount) && (this.userProfileReset.reporteeCount > 0)) {
                    this._showRoleChangeAlert(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_REPORTEES);
                }
                else if (angular.isDefined(this.userProfile.reporteeCount) && (this.userProfile.reporteeCount === 0)) {
                    this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
                }
            }
            else if (this.isCompanyAdmin(this.userProfile.userDetails.role)) {
                if (this.userProfile.reporteeCount > 0) {
                    this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.CHANGE_MANAGER_TO_ADMIN_REPORTEES);
                }
                else {
                    this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
                }
            }
        }
        else if (this.isHiringManager(this.userProfileReset.userDetails.role)) {
            if (this.isRecruiter(this.userProfile.userDetails.role) || this.isSeniorRecruiter(this.userProfile.userDetails.role)) {
                if (angular.isDefined(this.userProfileReset.reporteeCount) && (this.userProfileReset.reporteeCount > 0)) {
                    this._showRoleChangeAlert(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_REPORTEES);
                }
                else if (angular.isDefined(this.userProfile.reporteeCount) && (this.userProfile.reporteeCount === 0)) {
                    this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
                }
            }
            else if (this.isCompanyAdmin(this.userProfile.userDetails.role)) {
                if (this.userProfile.reporteeCount > 0) {
                    this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.CHANGE_MANAGER_TO_ADMIN_REPORTEES);
                }
                else {
                    this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
                }
            }
        }
        else if (this.isCompanyAdmin(this.userProfileReset.userDetails.role)) {
            if (this.isRecruiter(this.userProfile.userDetails.role) || this.isSeniorRecruiter(this.userProfile.userDetails.role)) {
                if (angular.isDefined(this.userProfileReset.reporteeCount) && (this.userProfileReset.reporteeCount > 0)) {
                    this._showRoleChangeAlert(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_REPORTEES);
                }
                else if (angular.isDefined(this.userProfile.reporteeCount) && (this.userProfile.reporteeCount === 0)) {
                    this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
                }
            }
            else if (this.isRecruitingManager(this.userProfile.userDetails.role) || this.isHiringManager(this.userProfile.userDetails.role)) {
                this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
            }
        }
        else {
            alert('Something went wrong ! please try again later');
        }
    }
    _showRoleChangeAlert(message) {
        bootbox.alert({
            closeButton: false,
            title: '<div class="alert alert-danger"><i class="fa fa-times-circle fa-fw fa-lg"></i><strong>Oh snap!</strong></div>',
            message: message,
            callback: () => {
                this.userProfile.userDetails.role = angular.copy(this.userProfileReset.userDetails.role);
                this.form.userDetailsForm.role.$setPristine();
            }
        });
    }
    _showRoleChangeConfirmation(message) {
        bootbox.confirm({
            closeButton: false, title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>", message: message,
            buttons: {
                confirm: {
                    label: 'Yes', className: 'btn-success'
                }, cancel: {
                    label: 'No', className: 'btn-danger'
                }
            },
            callback: (result) => {
                if (result) {
                    if (this.isCompanyAdmin(this.userProfileReset.userDetails.role)) {
                        this.userProfile.userDetails.manager = null;
                        this._getManagerListWhileDemotingAdmin(this.userProfile.userDetails.userId);
                        angular.element('#manager').attr({ 'readonly': false, 'disabled': false });
                    }
                    else {
                        this._getManagersList(this.userProfile.userDetails.userId, this.userProfile.userDetails.role.id, this.userProfile.buId);
                    }
                }
                else {
                    this.userProfile.userDetails.role = angular.copy(this.userProfileReset.userDetails.role);
                    this.form.userDetailsForm.role.$setPristine();
                }
            }
        });
    }
    /**
    * This method will be called when ever Manager is changed from ui
    */
    changeManagerObject() {
        if (this.userProfile.reporteeCount > 0) {
            var changeManagerMessage = this.MESSAGECONSTANTS.NOTIFICATIONS.USER.CHANGE_MANAGER_REPORTEES;
        }
        else {
            var changeManagerMessage = this.MESSAGECONSTANTS.NOTIFICATIONS.USER.CHANGE_MANAGER;
        }
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
            message: changeManagerMessage,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'No',
                    className: 'btn-danger'
                }
            },
            callback: (result) => {
                if (result) {
                    var managerid = angular.copy(this.userProfile.userDetails.manager.userId);
                    for (var i = 0; i < this.managerList.length; i++) {
                        if (managerid === this.managerList[i].userId) {
                            this.userProfile.userDetails.manager = angular.copy(this.managerList[i]);
                            this.updatedManager = angular.copy(this.userProfile.userDetails.manager);
                        }
                    }
                }
                else {
                    this.userProfile.userDetails.manager = angular.copy(this.userProfileReset.userDetails.manager);
                }
            }
        });
    }
    /**
     * This method is called when changed in CITY OR STATE OR COUNTY OR COUNTRY dropdowns.
     * This method will take care of changes to be made to other attributes when one
     * is changed among above specified one's.
     */
    changeAddressObject(type, obj) {
        this.saveButtonClicked = false;
        this.nextButtonClicked = false;
        switch (type) {
            case 'city':
                for (let p = 0; p < this.geoLocationsCopy.length; p++) {
                    if (this.geoLocationsCopy[p].city === obj) {
                        this.userProfile.userDetails.state = this.geoLocationsCopy[p].state;
                        this.userProfile.userDetails.country = this.geoLocationsCopy[p].country;
                        this.userProfile.userDetails.county = this.geoLocationsCopy[p].county;
                        if (angular.isDefined(this.geoLocationsCopy[p].county) && (this.geoLocationsCopy[p].county !== null)) {
                            this.isCountyExists = true;
                        }
                        else {
                            this.isCountyExists = false;
                        }
                        this.countryCode = this.geoLocationsCopy[p].countryCode;
                        this._setWorkTelephoneCountryCode();
                        this._setMobileNumberCountryCode();
                    }
                }
                break;
            case 'state':
                for (let p = 0; p < this.geoLocationsCopy.length; p++) {
                    if (this.geoLocationsCopy[p].state === obj) {
                        this.userProfile.userDetails.city = this.geoLocationsCopy[p].city;
                        this.userProfile.userDetails.country = this.geoLocationsCopy[p].country;
                        this.userProfile.userDetails.county = this.geoLocationsCopy[p].county;
                        if (angular.isDefined(this.geoLocationsCopy[p].county) && (this.geoLocationsCopy[p].county !== null)) {
                            this.isCountyExists = true;
                        }
                        else {
                            this.isCountyExists = false;
                        }
                        this.countryCode = this.geoLocationsCopy[p].countryCode;
                        this._setWorkTelephoneCountryCode();
                        this._setMobileNumberCountryCode();
                    }
                }
                break;
            case 'country':
                for (let p = 0; p < this.geoLocationsCopy.length; p++) {
                    if (this.geoLocationsCopy[p].country === obj) {
                        this.userProfile.userDetails.city = this.geoLocationsCopy[p].city;
                        this.userProfile.userDetails.state = this.geoLocationsCopy[p].state;
                        this.userProfile.userDetails.county = this.geoLocationsCopy[p].county;
                        if (angular.isDefined(this.geoLocationsCopy[p].county) && (this.geoLocationsCopy[p].county !== null)) {
                            this.isCountyExists = true;
                        }
                        else {
                            this.isCountyExists = false;
                        }
                        this.countryCode = this.geoLocationsCopy[p].countryCode;
                        this._setWorkTelephoneCountryCode();
                        this._setMobileNumberCountryCode();
                    }
                }
                break;
            case 'county':
                for (let p = 0; p < this.geoLocationsCopy.length; p++) {
                    if (this.geoLocationsCopy[p].county === obj) {
                        this.userProfile.userDetails.city = this.geoLocationsCopy[p].city;
                        this.userProfile.userDetails.country = this.geoLocationsCopy[p].country;
                        this.userProfile.userDetails.state = this.geoLocationsCopy[p].state;
                        this.countryCode = this.geoLocationsCopy[p].countryCode;
                        this._setWorkTelephoneCountryCode();
                        this._setMobileNumberCountryCode();
                    }
                }
                break;
        }
    }
    disableCountyFieldIfViewMode() {
        if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.VIEW) {
            angular.element('#county').attr({ 'readonly': true, 'disabled': true });
        }
    }
    toggleCopyCompanyAddress() {
        this.copyCompanyAddress = document.getElementById("copyCompanyAddress").checked;
        let companyAddressZipcode;
        if (this.copyCompanyAddress) {
            this.companyService.getCompanyDetails(this.$rootScope.userDetails.company.companyId, (data) => {
                companyAddressZipcode = data.company.zipcode;
                this.userProfile.userDetails.address1 = data.company.address1;
                this.userProfile.userDetails.address2 = data.company.address2;
                this.userProfile.userDetails.zipcode = companyAddressZipcode;
                this.cancelClicked = false;
                this._getAddressDetails(companyAddressZipcode, 'copycomanyaddress', (response) => {
                    angular.element('.companyaddresscopyenabled').attr({ 'readonly': true, 'disabled': true });
                });
            }, (error) => {
                if (this.$rootScope.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
        }
        else {
            this.copyCompanyAddress = false;
            angular.element('.companyaddresscopyenabled').attr({ 'readonly': false, 'disabled': false });
            if (this.accessMode == this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
                this.userProfile.userDetails.address1 = this.userProfileReset.userDetails.address1;
                this.userProfile.userDetails.address2 = this.userProfileReset.userDetails.address2;
                this.userProfile.userDetails.zipcode = this.userProfileReset.userDetails.zipcode;
                this._getAddressDetails(this.userProfile.userDetails.zipcode, 'zipchanged', (response) => {
                    if (angular.isDefined(this.userProfileReset.userDetails.county) && (this.userProfileReset.userDetails.county !== null)
                        && (this.userProfile.userDetails.zipcode === this.userProfileReset.userDetails.zipcode)) {
                        this.userProfile.userDetails.county = this.userProfileReset.userDetails.county;
                        // this.$scope.safeApply();
                    }
                });
            }
            else {
                this.userProfile.userDetails.address1 = this.userProfileReset.userDetails.address1;
                this.userProfile.userDetails.address2 = this.userProfileReset.userDetails.address2;
                this.userProfile.userDetails.zipcode = this.userProfileReset.userDetails.zipcode;
                this._getAddressDetails(this.userProfileReset.userDetails.zipcode, 'zipchanged', (response) => {
                    if (angular.isDefined(this.userProfileReset.userDetails.county) && (this.userProfileReset.userDetails.county !== null)
                        && (this.userProfile.userDetails.zipcode === this.userProfileReset.userDetails.zipcode)) {
                        this.userProfile.userDetails.county = this.userProfileReset.userDetails.county;
                        // this.$scope.safeApply();
                    }
                });
            }
        }
    }
    onUserBelongsToBUChanged() {
        this.isUserBelongsToBUChanged = true;
        let isBelongsToBUChangeValid = (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) ||
            ((this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) && ((this.nextButtonFlag > 0) || (this.saveButtonFlag > 0)));
        if (isBelongsToBUChangeValid) {
            if (this.userProfile.reporteeCount > 0) {
                bootbox.confirm({
                    closeButton: false,
                    title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
                    message: "All the users and employees in the hierarchy reporting to the user will also have their 'Belongs to BU' changed.<br> Do you wish to continue?",
                    className: "zIndex1060",
                    backdrop: true,
                    onEscape: false,
                    buttons: {
                        confirm: {
                            label: 'Yes',
                            className: 'btn-info'
                        },
                        cancel: {
                            label: 'Cancel',
                            className: 'btn-danger'
                        }
                    },
                    callback: (result) => {
                        if (result) {
                            this._setBuName();
                            this._getManagersList(this.userProfile.userDetails.userId, this.userProfile.userDetails.role.id, this.userProfile.buId);
                        }
                        else {
                            this.userProfile.buId = this.userProfileReset.buId;
                        }
                    }
                });
            }
            else {
                this._setBuName();
                this._getManagersList(this.userProfile.userDetails.userId, this.userProfile.userDetails.role.id, this.userProfile.buId);
            }
        }
    }
    getDepartments(searchTerm) {
        let searchObject = {
            'searchText': searchTerm,
            'companyId': this.companyId
        };
        return this.employeeService.getDepartmentsPromiseForTypeAhead(searchObject).then((data) => {
            return data;
        });
    }
    departmentTypeAheadDepartmentAdded(tag) {
        this.userProfile.departmentName = tag.name;
        if (!_.isUndefined(tag.id)) {
            this.userProfile.departmentId = tag.id;
        }
    }
    departmentTypeAheadDepartmentRemoved(tag) {
        this.userProfile.departmentId = null;
        this.userProfile.departmentName = null;
    }
    onClientOrBuSelection(clientOrBu) {
        if (!clientOrBu.enabled) {
            this.userService.checkIfUserHasRequisitionsInClientOrBu(this.companyId, this.userProfile.userDetails.userId, clientOrBu.id, (data) => {
                if (data) {
                    clientOrBu.enabled = !clientOrBu.enabled;
                    let clientOrBULabel = this.isStaffingCompany ? "Client" : "BU";
                    this._showClientOrBuCannotBeRemovedMessage(clientOrBULabel);
                }
                else if (!clientOrBu.enabled && clientOrBu.subordinatesBelongToBu) {
                    clientOrBu.enabled = !clientOrBu.enabled;
                    this._showClientOrBuUncheckableWarning(clientOrBu);
                }
            }, error => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    }
    onClientsBuSelection(bu) {
        if (!bu.enabled) {
            this.userService.checkIfUserHasRequisitionsInClientOrBu(this.companyId, this.userProfile.userDetails.userId, bu.buId, (data) => {
                if (data) {
                    bu.enabled = !bu.enabled;
                    this._showClientOrBuCannotBeRemovedMessage("Client's BU");
                }
            }, error => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    }
    _showClientOrBuCannotBeRemovedMessage(clientOrBULabel) {
        let title = clientOrBULabel + " cannot be removed";
        let message = "This " + clientOrBULabel + " cannot be removed as there are requisitions under this user that are associated with this " + clientOrBULabel + ".";
        bootbox.alert({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>" + title + "</strong></div>",
            message: message,
            className: "zIndex1060",
            buttons: {
                ok: {
                    label: 'Ok',
                    className: 'btn-info'
                }
            }
        });
    }
    _showClientOrBuUncheckableWarning(clientOrBu) {
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            windowTopClass: 'four-dot-five-modal-medium',
            component: 'addEditUserActionsModal',
            resolve: {
                userId: () => {
                    return this.userProfile.userDetails.userId;
                },
                buId: () => {
                    return clientOrBu.id;
                },
                isCorporate: () => {
                    return this.isCorporateFlag;
                }
            }
        });
    }
    //utilities
    handleLongName(longName, limitToMax) {
        return this.utilityService.handleLongName(longName, limitToMax);
    }
    getFullName(firstName, lastName) {
        return this.utilityService.getFullName(firstName, lastName);
    }
    isLoggedInUser(userDetails) {
        // return this.utilityService.isLoggedInUser(userDetails);
        return angular.equals(userDetails.userId, this.$rootScope.userDetails.id);
    }
    isSuperUser(role) {
        return this.userRoleService.isSuperUser(role);
    }
    isFourDotFiveAdmin(role) {
        return this.userRoleService.isFourDotFiveAdmin(role);
    }
    isCompanyAdmin(role) {
        // return this.userRoleService.isCompanyAdmin(role);
        return angular.equals(role.id, this.MESSAGECONSTANTS.ROLEIDS.STAFFING_ADMIN) || angular.equals(role.id, this.MESSAGECONSTANTS.ROLEIDS.CORPORATE_ADMIN);
    }
    isRecruitingManager(role) {
        return this.userRoleService.isRecruitingManager(role);
    }
    isHiringManager(role) {
        return this.userRoleService.isHiringManager(role);
    }
    isSeniorRecruiter(role) {
        return this.userRoleService.isSeniorRecruiter(role);
    }
    isRecruiter(role) {
        return this.userRoleService.isRecruiter(role);
    }
    /**
     * Forward Recipients fromDate and toDate validations are done in this method
     */
    checkDateValidation() {
        var enter = !angular.equals(this.userProfile.userForwardRecipientDetails, null) &&
            angular.isDefined(this.userProfile.userForwardRecipientDetails.forwardRecipient) &&
            !angular.equals(this.userProfile.userForwardRecipientDetails.forwardRecipient, null) &&
            angular.isDefined(this.userProfile.userForwardRecipientDetails.fromDate) &&
            !angular.equals(this.userProfile.userForwardRecipientDetails.fromDate, null) &&
            angular.isDefined(this.userProfile.userForwardRecipientDetails.toDate) &&
            !angular.equals(this.userProfile.userForwardRecipientDetails.toDate, null) &&
            !angular.equals(new Date(this.userProfile.userForwardRecipientDetails.fromDate).toString(), 'Invalid Date') &&
            !angular.equals(new Date(this.userProfile.userForwardRecipientDetails.toDate).toString(), 'Invalid Date');
        if (enter) {
            var keys = Object.keys(this.userProfile.userForwardRecipientDetails.forwardRecipient);
            var last = keys.slice(-2)[0];
            //delete this.userProfile.userForwardRecipientDetails.forwardRecipient[last];
            var datevalid = new Date(this.userProfile.userForwardRecipientDetails.fromDate).getTime() <= new Date(this.userProfile.userForwardRecipientDetails.toDate).getTime();
            if (!datevalid) {
                this.form.userForwardRecipientsform.$setValidity('date', false);
                this.form.userForwardRecipientsform.fromDate.$setValidity('date', false);
                this.form.userForwardRecipientsform.toDate.$setValidity('date', false);
            }
            else {
                this.form.userForwardRecipientsform.$setValidity('date', true);
                this.form.userForwardRecipientsform.fromDate.$setValidity('date', true);
                this.form.userForwardRecipientsform.toDate.$setValidity('date', true);
                var timevalid = angular.equals(new Date(this.userProfile.userForwardRecipientDetails.toDate + ' ' + this.userProfile.userForwardRecipientDetails.toTime).getTime(), NaN) ||
                    angular.equals(new Date(this.userProfile.userForwardRecipientDetails.fromDate + ' ' + this.userProfile.userForwardRecipientDetails.fromTime).getTime(), NaN) ||
                    (new Date(this.userProfile.userForwardRecipientDetails.toDate + ' ' + this.userProfile.userForwardRecipientDetails.toTime).getTime() > new Date(this.userProfile.userForwardRecipientDetails.fromDate + ' ' + this.userProfile.userForwardRecipientDetails.fromTime).getTime());
                if (!timevalid) {
                    if (!angular.equals(new Date(this.userProfile.userForwardRecipientDetails.toDate + ' ' + this.userProfile.userForwardRecipientDetails.toTime).getTime(), NaN) &&
                        !angular.equals(new Date(this.userProfile.userForwardRecipientDetails.fromDate + ' ' + this.userProfile.userForwardRecipientDetails.fromTime).getTime(), NaN)) {
                        this.form.userForwardRecipientsform.$setValidity('time', false);
                        this.form.userForwardRecipientsform.fromTime.$setValidity('time', false);
                        this.form.userForwardRecipientsform.toTime.$setValidity('time', false);
                    }
                }
                else {
                    this.form.userForwardRecipientsform.$setValidity('time', true);
                    this.form.userForwardRecipientsform.fromTime.$setValidity('time', true);
                    this.form.userForwardRecipientsform.toTime.$setValidity('time', true);
                }
            }
        }
        else {
            if (this.dateTimeCount <= 1) {
                var date = new Date();
                var time = date.toTimeString().split(' ')[0].split(':');
                this.userProfile.userForwardRecipientDetails.fromTime = time[0] + ':' + time[1] + ':' + time[2];
                this.userProfile.userForwardRecipientDetails.toTime = time[0] + ':' + time[1] + ':' + time[2];
                this.dateTimeCount++;
            }
            else {
                this.dateTimeCount++;
                var timevalid = angular.equals(new Date(this.userProfile.userForwardRecipientDetails.toDate + ' ' + this.userProfile.userForwardRecipientDetails.toTime).getTime(), NaN) ||
                    angular.equals(new Date(this.userProfile.userForwardRecipientDetails.fromDate + ' ' + this.userProfile.userForwardRecipientDetails.fromTime).getTime(), NaN) ||
                    (new Date(this.userProfile.userForwardRecipientDetails.toDate + ' ' + this.userProfile.userForwardRecipientDetails.toTime).getTime() > new Date(this.userProfile.userForwardRecipientDetails.fromDate + ' ' + this.userProfile.userForwardRecipientDetails.fromTime).getTime());
                this.form.userForwardRecipientsform.fromTime.$setValidity('time', true);
                this.form.userForwardRecipientsform.toTime.$setValidity('time', true);
            }
        }
    }
    single() {
    }
    //Handle navigating away when data is unsaved
    uiCanExit(transitions) {
        let toState = transitions.to().name;
        let toParams = transitions.params();
        let confirmationAtStep = this._getCurrentStep();
        if (angular.copy(this.showConfirmationPopup)) {
            this.showConfirmationPopup = false;
        }
        else if (this.accessMode !== this.MESSAGECONSTANTS.ACCESS_MODES.VIEW) {
            if ((confirmationAtStep === 1) && this._hasStepDataChanged(confirmationAtStep)) {
                this.showConfirmationPopup = true;
            }
            else if ((confirmationAtStep === 2) && this._hasStepDataChanged(confirmationAtStep)) {
                this.showConfirmationPopup = true;
            }
        }
        if (this.showConfirmationPopup && toState !== "login") {
            transitions.abort();
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
                message: "Unsaved data on the page will be lost. Do you still want to continue?",
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: (result) => {
                    if (result) {
                        // Handling data change when clicked on Switch company 
                        if (this.$rootScope.switchClicked) {
                            // this.companyService.showAllCompanies();
                            this.uibModalService.showAllCompanies();
                            this.$rootScope.switchClicked = false;
                        }
                        else {
                            this.clearData();
                            this.StorageService.remove('wizardoperations');
                            this.$state.go(toState, toParams, { reload: true });
                        }
                    }
                    else {
                        this.showConfirmationPopup = false;
                        if (this.$rootScope.switchClicked) {
                            this.$rootScope.switchClicked = false;
                        }
                    }
                }
            });
        }
        else {
            // If clicked on switch company without changing data
            if (this.$rootScope.switchClicked && !this._hasStepDataChanged(confirmationAtStep)) {
                transitions.abort();
                this.$timeout(() => {
                    // this.companyService.showAllCompanies();
                    this.uibModalService.showAllCompanies();
                }, 150);
                this.$rootScope.switchClicked = false;
            }
        }
    }
    _handleBrowserEvents() {
        //Handle Browser back/forward change
        let unbindLocationChangeEvent = this.$scope.$on('$locationChangeStart', (event, toState, toParams, fromState, fromParams) => {
            this.isLocationChange = this.isLocationChangeInitial;
            this.isLocationChangeInitial = true;
        });
    }
}
AddEditUserPageController.$inject = ['$scope', '$rootScope', '$state', '$timeout', '$filter', '$uibModal', '$transitions', 'StorageService', 'utilityService', 'userRoleService', 'employeeService', 'userService', 'companyService', 'USERMANAGEMENTCONSTANTS', 'MESSAGECONSTANTS', 'alertsAndNotificationsService', 'uibModalService'];
// import * as TEMPLATE from './add-edit-user-page.html';
import * as TEMPLATE from 'raw-loader!./add-edit-user-page.html';
export const AddEditUserPageComponent = {
    selector: 'addEditUserPage',
    component: {
        bindings: { $transition$: '<' },
        template: TEMPLATE.default,
        // templateUrl: 'app/partials/missioncontrol/addEditUser/add-edit-user-page.html',
        controller: AddEditUserPageController
    }
};
//# sourceMappingURL=add-edit-user-page.component.js.map